import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class MediaControlService {
  private currentMediaId = new Subject<string>();
  currentMedia$ = this.currentMediaId.asObservable();

  constructor() { }

  // Notifie qu'un nouveau média commence à jouer
  playMedia(mediaId: string) {
    this.currentMediaId.next(mediaId);
  }

  // Arrête tous les médias
  stopAll() {
    this.currentMediaId.next('');
  }
}
